import Container from '../components/layout/Container'
import CrackedEgg from '../assets/cracked-egg.svg'

const NotFound = () => (
    <Container className="text-center flex h-screen">
        <div className="m-auto">
            <img src={CrackedEgg} className="mx-auto mb-3 -mt-9" width={128} height={128} />
            <h1>Ooops! Page not found</h1>
        </div>
    </Container>
)

export default NotFound
